// extracted by mini-css-extract-plugin
module.exports = {"diceTextForm":"styles_diceTextForm__1EdVC","diceTextButton":"styles_diceTextButton__Kog_w"};